import type { EventName } from "@lit/react";
import { Tooltip as TooltipElement, type TooltipEventMap as _TooltipEventMap, } from "@vaadin/tooltip/vaadin-tooltip.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TooltipElement, };
export type TooltipEventMap = Readonly<{
    onContentChanged: EventName<_TooltipEventMap["content-changed"]>;
}>;
const events = { onContentChanged: "content-changed" } as TooltipEventMap;
export type TooltipProps = WebComponentProps<TooltipElement, TooltipEventMap>;
export const Tooltip = createComponent({
    elementClass: TooltipElement, events, react: React, tagName: "vaadin-tooltip"
});
